module.exports = __webpack_public_path__ + "static/img/topbg.740ab8a5.png";